import { render, staticRenderFns } from "./OrganMan.vue?vue&type=template&id=aa3d9398&scoped=true"
import script from "./OrganMan.vue?vue&type=script&lang=js"
export * from "./OrganMan.vue?vue&type=script&lang=js"
import style0 from "./OrganMan.vue?vue&type=style&index=0&id=aa3d9398&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa3d9398",
  null
  
)

export default component.exports